<script setup>
import {ref, onBeforeMount, computed} from "vue"
import {mallOrderItemStateEnum} from "@/enum/mallOrderItemStateEnum.js"
const props = defineProps({
  state: {
    required: true,
    type: String,
    default: 0
  }
})

// 执行订单判断
onBeforeMount(() => {

})

// 订单状态枚举
const orderState = mallOrderItemStateEnum
// 状态名称
const stateName = computed(() => {
  const order = mallOrderItemStateEnum.find(item => item.stateId === props.state)
  return order?.stateName || "未知状态"
})

// 展示的文本类型
const textType = computed(() => {
  switch (props.state) {
    case "UNPAID":
    case "CANCELLED":
      return "unpaid"
    case "NORMAL":
      return "default"
    case "REFUNDED":
      return "refunded"
    default:
      return "info"
  }
})
</script>

<template>
  <div class="mall_order_state">
    <span :class="textType">{{stateName}}</span>
  </div>
</template>

<style lang="scss" scoped>
.mall_order_state {
  font-family: OPPOSans;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  color: #272539;
  .unpaid {
    color: #94979D;
  }
  .default {
    color: #67C23A;
  }
  .refunded {
    color: #FF4847;
  }
}
</style>
